<script>
import FundraiserTabs from '@/components/fundraisers/public/fundraiser-tabs.vue'
import DonationsListGroup from '@/components/donations/public/donations-list-group.vue'
import FundraiserTeamAboutTabs from '../../../teams/public/fundraiser-team-about-tabs.vue'
import FundraiserTeamSlideShow from '../../../teams/public/fundraiser-team-slide-show.vue'
import FundraiserTeamTabs from '../../../teams/public/fundraiser-team-tabs.vue'

export default {
  name: 'FundraiserTeamLeftColumn',
  components: { FundraiserTeamTabs, FundraiserTeamSlideShow, FundraiserTeamAboutTabs, DonationsListGroup, FundraiserTabs },
  props: {
    fundraiser: {
      type: Object,
      required: true
    },
    team: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <div class="flex flex-col">
    <fundraiser-team-slide-show v-if="fundraiser.slideshow || team.slideshow" :team="team" :fundraiser="fundraiser" />
    <fundraiser-team-about-tabs :fundraiser="fundraiser" :team="team" class="mt-10" />
    <fundraiser-team-tabs :fundraiser="fundraiser" :team="team" class="mt-10" />
    <donations-list-group :fundraiser="fundraiser" :team="team" class="mt-10 lg:hidden" />
  </div>
</template>

<style scoped>

</style>
